<template>

    <section class="card text-center vehicle-resume hide-small" id="resume">
        <div class="sticky-thumb half-bottom-space" v-bind:class="{ isContactPage: contactPage}">
            <picture><img alt="" :src="`/photo/${Details.NewVehicle.Photo}`"/></picture>
        </div>

        <div class="resume all-100 medium-50">
            <h2>{{ Details.NewVehicle.BrandModel }}</h2>
            <p>{{ Details.NewVehicle.Version }}</p>
            <ul class="features">
                <li>{{ Details.NewVehicle.Fuel }}</li>
            </ul>
        </div>

        <div class="all-100 medium-50">
            <div class="tab-content">
                <div  id="price" class="tab-pane fade show active" role="tabpanel" aria-labelledby="price-tab">
                    <div v-if="Details.NewPrice != null" class="price">
                        <span class="old-price">{{ Details.Price.Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}<small>€</small></span>
                        <span>{{ Details.NewPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}<small>€</small></span>
                    </div>
                    <div v-else class="price">
                        <span>{{ Details.Price.Total?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}<small>€</small></span>
                    </div>
                    <div v-if="Details.ValidUntil != null" data-toggle="tooltip" data-placement="top" title="Validade da proposta" class="info">
                        Validade: {{formatedDate(Details.ValidUntil)}}
                        <i class="far fa-question-circle"></i></div>
                </div>
            </div>
        </div>
        <div class="all-100">
            <ul class="price-list">
                <li><span>Preço Base</span>{{ Details.Price.Base?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }} €</li>
                <li><span>Opcionais</span>{{ Details.Price.Extras?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} €</li>
                <li><span>ISV</span>{{ Details.Price.ISV?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} €</li>
                <li><span>IVA (23%)</span>{{ Details.Price.IVA?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}€</li>
                <li><span>Imposto Único de Circulação</span>{{ Details.Price.IUC?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }} €</li>
                <li><span>Custo transporte e administrativos</span> {{ Details.Price.Handling?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }} €</li>
                <li><span>Preço Chave na mão</span> {{Details.Price.Total?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} €</li>
            </ul>
        </div>
        <span>
            <a class="ink-button main-action top-space" href="/" data-toggle="modal" data-target="#loginModal" v-if="!contactPage">Contactar vendedor</a>
        </span>

    </section>
</template>

<script>
    import * as utils from "../scripts/utils.js";
    import * as Constants from "../scripts/constants"

    export default {

        props: {
            contactPage: Boolean,
            newVehicle: Boolean,
            adDetails: Object
        },
        data() {
            return { 
                Details: {
                    Price: {},
                    NewPrice: null,
                    ValidUntil: "",
                    NewVehicle: {
                        Kilometers: 0,
                        Fuel: "",
                        Year: 0,
                        BrandModel: "",
                        Version: "",
                        Photo: Constants.VEHICLE_IMAGE_DEFAULT,
                    }
                },

            }
        },
        methods:{
            formatedDate(input) {
                let date = utils.FormatDate(input, "dd/MM/yyyy");
                return utils.isNullOrEmpty(date) ? "" : date;
            },

            async loadData(){
                if (this.adDetails){
                    this.adDetails = JSON.parse(this.adDetails);
                    this.Details.NewPrice = this.adDetails.ProcurementInfo != null ? this.adDetails.ProcurementInfo.NewPrice : null;
                    this.Details.ValidUntil = this.adDetails.ProcurementInfo != null ? this.adDetails.ProcurementInfo.ValidUntil : null;
                    this.Details.Price = this.adDetails.Advert.Price;
                    this.Details.NewVehicle.Fuel = this.adDetails.Advert.NewVehicle.Fuel;
                    this.Details.NewVehicle.Year = this.adDetails.Advert.NewVehicle.YearProduction;
                    this.Details.NewVehicle.BrandModel = this.adDetails.Advert.NewVehicle.Brand + " " + this.adDetails.Advert.NewVehicle.Model;
                    this.Details.NewVehicle.Version = this.adDetails.Advert.NewVehicle.Version;
                    this.Details.NewVehicle.Kilometers = this.adDetails.Advert.NewVehicle.Km;
                    if (this.adDetails.Advert.NewVehicle.Photos)
                    { 
                        this.Details.NewVehicle.Photo = this.adDetails.Advert.NewVehicle.Photos[0]; 
                    }
                }
            }
        },
        mounted () {
            this.loadData();
        }
    };

</script>